@if(isSubmitting() || isDisabled){
    <app-loader></app-loader>
}
<div class="tax-page">
    <!-- TOP HEADER -->
    <div class="page-header">
        <div>
            <h2>Income Tax Provisional TDS Generator</h2>
            <p class="subtitle">Background Processing &bull; Resilient 24+ Hour Execution</p>
        </div>

        <!-- TABS NAVIGATION -->
        <div class="tabs-nav">
            <div class="action-bar">
            </div>
            <button class="tab-btn" [class.tab-active]="activeTab() === 'live'" (click)="activeTab.set('live')">
                ⚡ Live Monitor
            </button>
            <button class="tab-btn" [class.tab-active]="activeTab() === 'history'"
                (click)="activeTab.set('history'); loadBatchHistory();">
                📊 Batch History &amp; Logs
            </button>
            <!-- @if (activeJob()) {
        <button class="btn-outline" (click)="resetView()">Start New Batch</button>
      } -->
        </div>
    </div>

    <!-- ========================================== -->
    <!-- TAB 1: LIVE MONITOR & TRIGGER              -->
    <!-- ========================================== -->
    @if (activeTab() === 'live') {

    <!-- 1. PARAMETERS & TRIGGER CARD -->
    <div class="card">
        <!-- <h3 class="card-title">Filter Criteria &amp; Generation Parameters</h3> -->

        <!-- 🔒 CONCURRENCY WARNING BANNER -->
        @if (isJobRunning()) {
        <div class="lock-banner">
            🔒 <strong>Batch {{ activeJob()?.id }} is currently RUNNING.</strong>
            Another batch cannot be started until this completes or is cancelled.
        </div>
        }

        <div class="grid-form">
            <div class="form-group">
                <label>Financial Year <span class="text-danger">*</span> </label>
                <ng-select name="FinancialYear" [items]="FinancialYears" bindLabel="FinancialYear"
                        bindValue="FinancialYear" [(ngModel)]="formData.financialYear"
                        placeholder="Financial Year" required>
                    </ng-select>
                <!-- <select [(ngModel)]="formData.financialYear" [disabled]="isSubmitting() || isJobRunning()">
                    <option value="2026-2027">2026-2027</option>
                    <option value="2025-2026">2025-2026</option>
                    <option value="2024-2025">2024-2025</option>
                </select> -->
            </div>

            <div class="form-group">
                <label>Branch</label>
                <!-- <input type="number" [(ngModel)]="formData.branchID" [disabled]="isSubmitting() || isJobRunning()"> -->
                <ng-select name="branch" [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="formData.branchID" (change)="ComboLoad('Client')" placeholder="Select Branch">
                </ng-select>
            </div>

            <div class="form-group">
                <label>Client</label>
                <!-- <input type="number" [(ngModel)]="formData.clientID" [disabled]="isSubmitting() || isJobRunning()"> -->
                <ng-select name="client" [items]="Clients" bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                    [(ngModel)]="formData.clientID" (change)="ComboLoad('Site');" placeholder="Select Client">
                </ng-select>
            </div>

            <div class="form-group">
                <label>Site</label>
                <!-- <input type="number" [(ngModel)]="formData.siteID" [disabled]="isSubmitting() || isJobRunning()"> -->
                <ng-select name="site" [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="formData.siteID" placeholder="Select Site">
                </ng-select>
            </div>

            <div class="form-group">
                <label for="empType">Employee Type</label>
                <select id="empType" [(ngModel)]="formData.empType" name="empType"
                    [disabled]="isSubmitting() || isJobRunning()">
                    <option value="" disabled>Select All</option>
                    <option value="Front">Front</option>
                    <option value="Back">Back</option>
                </select>
            </div>

            <!-- SINGLE EMPLOYEE CODE FILTER -->
            <div class="form-group">
                <label>Employee Code</label>
                <input type="text" placeholder="e.g. EMP1024" [(ngModel)]="formData.empCode"
                    [disabled]="isSubmitting() || isJobRunning()">
            </div>

            <div class="mt-4 row">
                <button class="btn btn-primary me-3 ms-2 col-auto" (click)="startProcess()" [disabled]="isSubmitting() || isJobRunning()">
                    @if (isSubmitting()) {
                    <span>Generate (&lt; 30ms)...</span>
                    } @else {
                    <span>Generate</span>
                    }
                </button>

                <button class="btn-outline col-auto" (click)="checkJobStatus()">🔄 Refresh List</button>
            </div>
        </div>
    </div>

    <!-- 2. LIVE MONITOR CARD (Shown when a job is active) -->
    @if (activeJob(); as job) {
    <div class="card monitor-card">

        <!-- SUCCESS BANNER -->
        @if (job.status === 'COMPLETED') {
        <div class="completion-banner">
            <div class="completion-icon">✓</div>
            <div>
                <h4>Batch Process Complete!</h4>
                <p>All {{ job.totalEmployees | number }} employees were processed successfully.</p>
            </div>
            <button class="btn-close-batch" (click)="resetView()">Close &amp; Finish</button>
        </div>
        }

        <!-- CANCELLED BANNER -->
        @if (job.status === 'CANCELLED') {
        <div class="cancelled-banner">
            <div class="cancelled-icon">✕</div>
            <div>
                <h4>Batch Process Cancelled</h4>
                <p>The process was manually stopped. Processed: {{ job.processedCount | number }} of {{
                    job.totalEmployees | number }}.</p>
            </div>
            <button class="btn-close-batch" (click)="resetView()">Close &amp; Start New</button>
        </div>
        }

        <!-- STATUS HEADER -->
        <div class="monitor-header">
            <div>
                <div class="badge-row">
                    <span class="badge" [class.badge-running]="job.status === 'RUNNING'"
                        [class.badge-completed]="job.status === 'COMPLETED'"
                        [class.badge-cancelled]="job.status === 'CANCELLED'">
                        {{ job.status }}
                    </span>
                    <span class="tracking-id">Batch ID: <strong>{{ job.id }}</strong></span>

                    <!-- MANUAL CANCEL / STOP BUTTON -->
                    @if (job.status === 'RUNNING') {
                    <button class="btn-cancel-batch" (click)="cancelCurrentBatch()">
                        ⏹ Stop / Cancel Batch
                    </button>
                    }

                    @if (job.status === 'RUNNING') {
                    <button class="btn-warning-batch" (click)="wakeUpDaemon()">
                        📄 Restart
                    </button>
                    }
                </div>
                <h2>{{ job.processedCount | number }} of {{ job.totalEmployees | number }} Employees Processed</h2>
            </div>

            <div class="kpi-group">
                <div class="kpi">
                    <span class="kpi-label">Progress</span>
                    <span class="kpi-value highlight">{{ progressPercent() }}%</span>
                </div>
                <div class="kpi">
                    <span class="kpi-label">Pending</span>
                    <span class="kpi-value">{{ job.pendingCount | number }}</span>
                </div>
                <div class="kpi">
                    <span class="kpi-label">Successful</span>
                    <span class="kpi-value text-success">{{ job.successCount | number }}</span>
                </div>
                <div class="kpi">
                    <span class="kpi-label">Failed</span>
                    <span class="kpi-value text-danger">{{ job.failedCount | number }}</span>
                </div>
            </div>
        </div>

        <!-- PROGRESS BAR -->
        <div class="progress-bar-container">
            <div class="progress-bar-fill" [style.width.%]="progressPercent()"></div>
        </div>

        <!-- HEARTBEAT TEXT -->
        @if (job.lastHeartbeat) {
        <p class="heartbeat-text">
            <span class="pulse-dot"></span> Server: {{ job.lastHeartbeat | date:'mediumTime' }} &bull; Active
            in background
        </p>
        }

        <!-- LIVE STREAM TABLE -->
        <div class="table-section">
            <h3>Live Processed Stream (Latest Records)</h3>
            <div class="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Emp Code</th>
                            <th>Emp ID</th>
                            <th>Employee Name</th>
                            <th>Status</th>
                            <th>Processed At</th>
                            <th>Error Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (emp of job.processedList; track emp.employeeId) {
                        <tr>
                            <td><code class="emp-code-badge">{{ emp.empCode || '-' }}</code></td>
                            <td><strong>#{{ emp.employeeId }}</strong></td>
                            <td>{{ emp.employeeName }}</td>
                            <td>
                                <span class="status-tag" [class.tag-success]="emp.status === 'SUCCESS'"
                                    [class.tag-failed]="emp.status === 'FAILED'">
                                    {{ emp.status }}
                                </span>
                            </td>
                            <td>{{ emp.processedAt | date:'mediumTime' }}</td>
                            <!-- <td class="error-cell">{{ emp.errorMessage || '-' }}</td> -->
                            <td class="error-cell" style="white-space: normal !important;
           overflow-wrap: anywhere;
           word-break: break-word;
           min-width: 300px;
           max-width: 450px;
           vertical-align: top;
           line-height: 1.6;">
                                {{ emp.errorMessage || '-' }}
                            </td>
                        </tr>
                        } @empty {
                        <tr>
                            <td colspan="6" class="text-center">Processing in progress... rows will stream
                                automatically.</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>

    </div>
    }

    }

    <!-- ========================================== -->
    <!-- TAB 2: ALL BATCHES & PROCESSED LOGS        -->
    <!-- ========================================== -->
    @if (activeTab() === 'history') {
    <div class="card">
        <div class="history-header">
            <div>
                <h3 class="card-title">All Processed Batches &amp; Audit Logs</h3>
                <p class="subtitle">History of all execution</p>
            </div>
            <button class="btn-outline" (click)="loadBatchHistory()">🔄 Refresh List</button>
        </div>

        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th>Batch ID</th>
                        <th>FY</th>
                        <th>Status</th>
                        <th>Total Emps</th>
                        <th>Processed</th>
                        <th>Success</th>
                        <th>Failed</th>
                        <th>Started At</th>
                        <th>Completed At</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    @for (batch of batchList(); track batch.batchId || batch.BatchId) {
                    <tr>
                        <td><code>{{ batch.jobGuid || batch.JobGuid }}</code></td>
                        <td>{{ batch.financialYear || batch.FinancialYear }}</td>
                        <td>
                            <span class="badge" [class.badge-running]="(batch.status || batch.Status) === 'RUNNING'"
                                [class.badge-completed]="(batch.status || batch.Status) === 'COMPLETED'"
                                [class.badge-cancelled]="(batch.status || batch.Status) === 'CANCELLED'">
                                {{ batch.status || batch.Status }}
                            </span>
                        </td>
                        <td><strong>{{ (batch.totalEmployees ?? batch.TotalEmployees) | number }}</strong></td>
                        <td>{{ (batch.processedCount ?? batch.ProcessedCount) | number }}</td>
                        <td class="text-success font-bold">{{ (batch.successCount ?? batch.SuccessCount) | number }}
                        </td>
                        <td class="text-danger font-bold">{{ (batch.failedCount ?? batch.FailedCount) | number }}</td>
                        <td>{{ (batch.createdOn || batch.CreatedOn) | date:'short' }}</td>
                        <td>{{ (batch.completedOn || batch.CompletedOn) ? ((batch.completedOn || batch.CompletedOn) |
                            date:'short') : 'In Progress...' }}</td>
                        <td>
                            <button class="btn-view-logs" (click)="viewBatchLogs(batch)">
                                🔍 Logs
                            </button>
                        </td>
                    </tr>
                    } @empty {
                    <tr>
                        <td colspan="10" class="text-center">No batches recorded yet.</td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    }

    <!-- ========================================== -->
    <!-- LOGS DETAIL MODAL                          -->
    <!-- ========================================== -->
    @if (selectedBatch(); as batch) {
    <div class="modal-backdrop">
        <div class="modal-card">

            <div class="modal-header">
                <div>
                    <h2>Processed Employee Logs: <code>{{ batch.jobGuid || batch.JobGuid }}</code></h2>
                    <p class="subtitle">Showing {{ batchLogs().length }} of {{ logsTotalCount() | number }} total logged
                        records</p>
                </div>
                <button class="btn-close-modal" (click)="closeLogsModal()">✕</button>
            </div>

            <!-- FILTERS -->
            <div class="modal-filters">
                <div class="filter-pills">
                    <button class="pill" [class.pill-active]="logStatusFilter() === ''"
                        (click)="logStatusFilter.set(''); fetchLogs();">
                        All ({{ logsTotalCount() | number }})
                    </button>
                    <button class="pill pill-success" [class.pill-active]="logStatusFilter() === 'SUCCESS'"
                        (click)="logStatusFilter.set('SUCCESS'); fetchLogs();">
                        Success Only
                    </button>
                    <button class="pill pill-danger" [class.pill-active]="logStatusFilter() === 'FAILED'"
                        (click)="logStatusFilter.set('FAILED'); fetchLogs();">
                        Failed Only (Errors)
                    </button>
                </div>

                <div class="search-box">
                    <input type="text" placeholder="Search Emp Code / Name / ID..." [(ngModel)]="logSearchQuery"
                        (keyup.enter)="fetchLogs()">
                    <button class="btn-search" (click)="fetchLogs()">Search</button>
                </div>
            </div>

            <!-- LOGS TABLE -->
            <div class="table-container modal-table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Log ID</th>
                            <th>Emp Code</th>
                            <th>Emp ID</th>
                            <th>Employee Name</th>
                            <th>Status</th>
                            <th>Processed At</th>
                            <th>Error Message</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (log of batchLogs(); track log.detailId) {
                        <tr>
                            <td>#{{ log.detailId }}</td>
                            <td><code class="emp-code-badge">{{ log.empCode || '-' }}</code></td>
                            <td><strong>{{ log.employeeId }}</strong></td>
                            <td>{{ log.employeeName }}</td>
                            <td>
                                <span class="status-tag" [class.tag-success]="log.status === 'SUCCESS'"
                                    [class.tag-failed]="log.status === 'FAILED'">
                                    {{ log.status }}
                                </span>
                            </td>
                            <td>{{ log.processedAt | date:'mediumTime' }}</td>
                            <!-- <td class="error-cell">{{ log.errorMessage || '-' }}</td> -->
                            <td class="error-cell" style="white-space: normal !important;
           overflow-wrap: anywhere;
           word-break: break-word;
           min-width: 300px;
           max-width: 450px;
           vertical-align: top;
           line-height: 1.6;">
                                {{ log.errorMessage || '-' }}
                            </td>
                            <td>
                                @if(log.status !== "SUCCESS"){
                                <button class="btn-reprocess" (click)="reprocessEmp(log)">
                                    🔄 Reprocess
                                </button>}
                            </td>
                        </tr>
                        } @empty {
                        <tr>
                            <td colspan="8" class="text-center">No logs match the selected filter.</td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>

            <!-- ✅ PAGINATION CONTROLS FOOTER -->
            <div class="modal-pagination">
                <div class="page-info">
                    Showing
                    <strong>{{ (logPage() - 1) * 50 + 1 }} - {{ endRecord() }}</strong>
                    of <strong>{{ logsTotalCount() | number }}</strong> records
                </div>

                <div class="page-buttons">
                    <button class="btn-page" (click)="goToFirstPage()" [disabled]="logPage() === 1 || isLoadingLogs()">
                        ⏮ First
                    </button>
                    <button class="btn-page" (click)="goToPrevPage()" [disabled]="logPage() === 1 || isLoadingLogs()">
                        ◀ Prev
                    </button>

                    <span class="page-indicator">
                        Page <strong>{{ logPage() }}</strong> of <strong>{{ totalPages() }}</strong>
                    </span>

                    <button class="btn-page" (click)="goToNextPage()"
                        [disabled]="logPage() >= totalPages() || isLoadingLogs()">
                        Next ▶
                    </button>
                </div>
            </div>

        </div>
    </div>
    }
</div>